import React from 'react';

// Componentes de formulário compartilhados pelo wizard de cadastro.
// Todos aplicam o mesmo estilo (rounded-xl, border, focus roxo).

/** Item de checkbox com estilo de "chip selecionável" — usado em grids de opções. */
export const CheckboxItem = ({ id, label, checked, onChange, icon }) => (
  <label
    htmlFor={id}
    className={`flex items-center gap-3 p-3 rounded-xl border-2 cursor-pointer transition-all ${
      checked
        ? 'border-[var(--primary)] bg-[var(--primary)]/5'
        : 'border-[var(--border)] hover:border-[var(--primary)]/50'
    }`}
  >
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      className="w-5 h-5 rounded border-[var(--border)] text-[var(--primary)] focus:ring-2 focus:ring-[var(--primary)]/20"
    />
    {icon && <span className="text-lg">{icon}</span>}
    <span className="text-sm font-medium">{label}</span>
  </label>
);

/** Input padrão com label + asterisco opcional. */
export const FormInput = ({ label, required, ...props }) => (
  <div>
    <label className="block text-sm font-medium mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      {...props}
      className="w-full px-4 py-3 rounded-xl border border-[var(--border)] focus:ring-2 focus:ring-[var(--primary)]/20 focus:border-[var(--primary)] transition-all"
    />
  </div>
);

/** Textarea com label + asterisco opcional. */
export const FormTextarea = ({ label, required, ...props }) => (
  <div>
    <label className="block text-sm font-medium mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <textarea
      {...props}
      className="w-full px-4 py-3 rounded-xl border border-[var(--border)] focus:ring-2 focus:ring-[var(--primary)]/20 focus:border-[var(--primary)] transition-all"
    />
  </div>
);

/** Select com label + asterisco opcional. Children devem ser <option>. */
export const FormSelect = ({ label, required, children, ...props }) => (
  <div>
    <label className="block text-sm font-medium mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <select
      {...props}
      className="w-full px-4 py-3 rounded-xl border border-[var(--border)] focus:ring-2 focus:ring-[var(--primary)]/20 focus:border-[var(--primary)] transition-all"
    >
      {children}
    </select>
  </div>
);
